import styled from "styled-components"

import { colors } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsSection } from "src/components/Paradise/ParadiseDetailsLayout"
import { ParadiseShippingZone } from "src/components/Paradise/ParadiseShipping/ParadiseShippingMethods/ParadiseShippingMethodDetails/ParadiseShippingMethodZone"
import { TParadiseShippingMethod } from "src/data/paradise/paradiseShipping/paradiseShippingTypes"
import { spacing } from "src/ui/spacing"

export function ParadiseShippingMethodZonesSection({
  shippingMethod,
}: {
  shippingMethod: TParadiseShippingMethod
}) {
  return (
    <ParadiseDetailsSection title="Zones">
      <Box>
        {shippingMethod.zones.map((zone, i) => (
          <ParadiseShippingZone
            key={i}
            zone={zone}
            currency={shippingMethod.currency_code}
          />
        ))}
      </Box>
    </ParadiseDetailsSection>
  )
}

const Box = styled.div`
  > :not(:last-child) {
    border-bottom: 1px solid ${colors.divider};
    padding-bottom: ${spacing.L};
  }

  display: grid;
  gap: ${spacing.L};
`
